import { useParams } from "react-router-dom";
import ContainerTitulo from "../../../components/Formularios/Container/ContainerTitulo";
import FormTicket from "./formulario";

export function TicketEditar() {
  const idticket = useParams();
  return (
    <>
      <div className="container-fluid mt-2">
        <ContainerTitulo titulo={`Editar Ticket - [#${idticket.id}]`} />
        <FormTicket idticket={idticket.id} acao="Editar" />
      </div>
    </>
  );
} 